const STORAGE_BASE = "https://wbaxbypftpczinlkdwvy.supabase.co/storage/v1";
const OBJECT_PATH  = `${STORAGE_BASE}/object/public/`;
const RENDER_PATH  = `${STORAGE_BASE}/render/image/public/`;

/**
 * Rewrites a Supabase Storage URL to use the image transform API.
 * Non-Supabase URLs are returned unchanged.
 *
 * @param {string} url
 * @param {object} opts
 * @param {number} opts.width   - target width  (default 600)
 * @param {number} opts.height  - target height (default 750, i.e. 4/5 ratio)
 * @param {number} opts.quality - WebP quality 1–100 (default 80)
 * @param {string} opts.resize  - "cover" (default, crops to box) | "contain" (no crop, letterbox)
 */
export function imgUrl(url, { width = 600, height = 750, quality = 80, resize = "cover" } = {}) {
  if (!url || !url.includes(OBJECT_PATH)) return url;
  const cleanPath = url.replace(OBJECT_PATH, "").split("?")[0];
  return `${RENDER_PATH}${cleanPath}?width=${width}&height=${height}&quality=${quality}&format=webp&resize=${resize}`;
}

/**
 * Transforms an array of image URLs.
 */
export function imgUrls(urls, opts) {
  return (urls ?? []).map((u) => imgUrl(u, opts));
}

/**
 * Adds Pexels resizing/compression query params to a Pexels image URL.
 * Non-Pexels URLs are returned unchanged.
 *
 * @param {string} url
 * @param {object} opts
 * @param {number} opts.width   - target width  (default 600)
 */
export function pexelsImg(url, { width = 600 } = {}) {
  if (!url || !url.includes("images.pexels.com")) return url;
  const base = url.split("?")[0];
  return `${base}?auto=compress&cs=tinysrgb&w=${width}`;
}
